import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect } from "react"
import List from "../../../components/List/List"
import { employeeMemory } from "../../../Objects/Memory/Memory"
import { useGetEmployee } from "../../../hooks/Employee/useGetEmployee"
import { useEmployeeContext } from "../../../context/useMenuEmployeeContext"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useTranslation } from "react-i18next"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"

export const EmployeesPage: React.FC = () => {
  const { t } = useTranslation("employee")

  const { handleGetEmployee } = useGetEmployee()

  const { setEmployee, handleOpenEmployee, setTitle, setIsMaster } = useEmployeeContext()

  useEffect(() => {
    setTitle(t("title_popup_create_employee"))

    handleGetEmployee(() => {})
  }, [])

  const handleSwitchEditeOrAdd = () => {
    setEmployee(null)

    handleOpenEmployee()
  }

  useOnboardingCreatePopup(handleSwitchEditeOrAdd)

  const handleFindApi = async () => {
    await handleGetEmployee(() => {})
  }

  const handleOpenEditeEmployee = (id: number) => {
    const employee = employeeMemory.findById(id)!

    if (employee.isMaster === false) {
      setEmployee(employee)

      setIsMaster(employee.isMaster)

      handleOpenEmployee()
    }
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          messageCount={t("list:label_employee_page_message_count")}
          messageEmpty={t("list:label_employee_page_message_empty")}
          nameFindSearch={t("list:label_employee_page_place_holder")}
          data={employeeMemory.getListCards(true)}
          handleAddButton={handleSwitchEditeOrAdd}
          handleRefreshButton={handleFindApi}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleOnClick={(e) => handleOpenEditeEmployee(e)}
        />
      </div>
    </>
  )
}
